import { orderBy } from "lodash";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Paper } from "material-ui";
import {
	actionGetHomeStats,
	actionChangeBiModuleProps,
	actionGetChildrenStats
} from "../../actions/BIModuleActions";
import {
	actionChangeLocationProps,
	actionGetProvinces
} from "../../actions/ProvinceActions";
// BI Module
import BiChart from "../../components/BiChart/BiChart";
import BaseClass from "./BaseClass";
import Data from "./DataLibrary";
// colores
import { C_VERDE, C_VERDE_CLARO, C_ROJO, C_ROSA } from "./DataConfig";
// reducers para los datos
import { R_HombresMujeresAfiliadosNoafiliados_cant } from "./DataConfig";

class indexProvincias extends BaseClass {
	/*
   * Render functions
   */

	renderDdjxProvincia(all_data) {
		const { year, provincias } = this.props.biModule;
		// proceso datos & defino colores
		const tmp = Data.reduceByProvince(
			all_data,
			R_HombresMujeresAfiliadosNoafiliados_cant
		);
		tmp.map(item => {
			return (item.name = provincias[item.name]);
		});
		// ordeno de mayor a menor
		const data = orderBy(
			tmp,
			[
				function(row) {
					return (
						row["Afiliados Hombres"] +
						row["Afiliados Mujeres"] +
						row["No Afiliados Hombres"] +
						row["No Afiliados Mujeres"]
					);
				}
			],
			["desc"]
		);
		// genero los graficos
		const colors = {
			"Afiliados Hombres": C_VERDE,
			"Afiliados Mujeres": C_VERDE_CLARO,
			"No Afiliados Hombres": C_ROJO,
			"No Afiliados Mujeres": C_ROSA
		};
		return this.renderCard(
			`Ranking de Declaraciones por provincia (${year})`,
			<BiChart
				type="bar.vertical"
				data={data}
				colors={colors}
				width={700}
				YAxisWidth={150}
				YAxisInterval={0}
			/>
		);
	}

	renderAfiliadosxProvincia(all_data) {
		const { year, provincias } = this.props.biModule;
		// proceso datos & defino colores
		const tmp = Data.reduceByProvince(
			all_data,
			R_HombresMujeresAfiliadosNoafiliados_cant
		);
		tmp.map(item => {
			return (item.name = provincias[item.name]);
		});
		// ordeno de mayor a menor
		const data = orderBy(
			tmp,
			[
				function(row) {
					return row["Afiliados Hombres"] + row["Afiliados Mujeres"];
				}
			],
			["desc"]
		);
		// genero los graficos
		const colors = {
			"Afiliados Hombres": C_VERDE,
			"Afiliados Mujeres": C_VERDE_CLARO
		};
		return this.renderCard(
			`Ranking de Afiliados por provincia (${year})`,
			<BiChart
				type="bar.vertical"
				data={data}
				colors={colors}
				width={700}
				height={400}
				YAxisWidth={150}
				YAxisInterval={0}
			/>
		);
	}

	render() {
		// datos
		let homeStats = this.getHomeStats();
		// graficos de Afiliados / No Afiliados
		const AfiliadosxProvincia = this.renderAfiliadosxProvincia(homeStats);
		// graficos declacaciones
		const DdjjxProvincia = this.renderDdjxProvincia(homeStats);
		// all done
		let header = this.renderHeaderReport({ title: "Provincias" });
		let mapa = this.renderMapaArgentina({
			type: "card",
			title: "Filtre por provincia"
		}); //[paper,card,null]
		return (
			<Paper zDepth={2} style={{ padding: "30px", marginBottom: "30px" }}>
				{header}
				<div style={{ display: "flex", flexDirection: "row" }}>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							marginTop: "18px"
						}}
					>
						{DdjjxProvincia}
						<div style={{ marginTop: "18px" }}>{AfiliadosxProvincia}</div>
					</div>
					<div style={{ flex: 1, marginLeft: "5px" }}>{mapa}</div>
				</div>
			</Paper>
		);
	}
}

function mapStateToProps(store) {
	const provincias = Data.reduceToObject(
		store.locations.provinciasList,
		"id",
		row => row.name
	);
	const biModule = Object.assign({}, store.biModule, { provincias });
	return {
		biModule: biModule,
		provincias: store.locations.provinciasList,
		session: store.session,
		login: store.session.authenticated,
		rol: store.app.rol
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionGetHomeStats,
			actionChangeBiModuleProps,
			actionGetChildrenStats,
			actionChangeLocationProps,
			actionGetProvinces
		},
		dispatch
	);
}
export default connect(mapStateToProps, mapDispatchToProps)(indexProvincias);



// WEBPACK FOOTER //
// ./src/screens/biCharts/indexProvincias.js